import React from 'react';

const CalendarIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
            <path d="M12.1363 2.78571V0.5" stroke="currentColor" strokeLinecap="square" />
            <path d="M4.86364 2.78571V0.5" stroke="currentColor" strokeLinecap="square" />
            <path d="M0.5 5.8331H16.5" stroke="currentColor" />
            <rect x="0.5" y="2.78564" width="16" height="13.7143" stroke="currentColor" strokeLinecap="square" />
        </svg>
    );
};

export default CalendarIcon;
